import React, { useEffect, useState } from "react";
import styles from "../../Styles/CreatorDash/styles.module.css";
import Header from "../../Base/Header";
import Courses from "../../Components/CreatorsDash/Courses";
import Manage from "../../Components/CreatorsDash/Manage";
import VideoList from "../../Components/CreatorsDash/VideoList";
import { isAuthenticated } from "../../helper/authApiCalls/auth";
import { useNavigate } from "react-router-dom";
import Footer from "../../Base/Footer";

const CreatorDash = () => {
  const navigate = useNavigate();
  const [menu, setMenu] = useState("course");
  const [list, setList] = useState({});

  // const PlayListContext = React.createContext();

  const borderStyle = (menuname) => {
    if (menuname === menu) {
      return "3px solid black";
    } else {
      return "none";
    }
  };

  useEffect(() => {
    if (!isAuthenticated()) {
      return navigate("/signin");
    }
    if (isAuthenticated() && isAuthenticated().role !== "creator") {
      return navigate("/profile");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div>
        <Header />
        <div className={styles.dash}>
          <div className={styles.dash1}>
            <span>Creator's Dashboard</span>
          </div>
          <div className={styles.dash2}>
            <div className={styles.button}>
              <div className={styles.button1}>
                <button
                  onClick={() => setMenu("course")}
                  style={{ borderBottom: borderStyle("course") }}
                >
                  Courses
                </button>
              </div>
              <div className={styles.button2}>
                <button
                  onClick={() => setMenu("manage")}
                  style={{ borderBottom: borderStyle("manage") }}
                >
                  Manage Profile
                </button>
              </div>
            </div>
          </div>
          {isAuthenticated() && isAuthenticated().role === "creator" && (
            <div className={styles.comp}>
              {menu === "course" && (
                <Courses
                  menu={menu}
                  setMenu={setMenu}
                  setList={setList}
                  list={list}
                />
              )}
              {menu === "manage" && <Manage />}
              {menu === "list" && <VideoList list={list} setList={setList} />}
            </div>
          )}
        </div>
        <Footer />
      </div>
    </>
  );
};
export default CreatorDash;
